module.exports = __webpack_public_path__ + "img/silver.be5030ca.webp";